//toggle account dropdown
blue.ready('headerAccount', '.header-utilAccountTrigger', trigger => {
  const storage = window.sessionStorage.getItem('signIn') || false;
  const menu = trigger.closest('.header-utilAccount');
  const closeBtn = menu.querySelector('.header-utilAccountClose');
  const closeBody = document.querySelector('.main');
  const closeHeader = document.querySelector('.header-main');

  const toggle = function (e) {
    if (e) e.preventDefault();
    menu.classList.toggle('is-active');
  };
  const bodyClass = document
    .querySelector('body')
    .classList.contains('homepage');

  const close = function (e) {
    menu.classList.remove('is-active');
  };

  const open = function () {
    menu.classList.add('is-active');
  };

  const docClose = function (e) {
    if (
      !e.target.closest('.header-utilAccount') &&
      !e.target.matches('.header-utilAccount')
    ) {
      document
        .querySelector('.header-utilAccount')
        .classList.remove('is-active');
    }
  };

  const init = function () {
    let timeout;
    let cancel = e => {
      clearTimeout(timeout);
      document.addEventListener('click', docClose);
      menu.removeEventListener('mouseover', cancel);
    };
    open();
    menu.addEventListener('mouseover', cancel);

    timeout = setTimeout(() => {
      close();
      document.addEventListener('click', docClose);
    }, 6500);
  };

  if(trigger) { trigger.addEventListener('click', toggle); }
  if(closeBtn) { closeBtn.addEventListener('click', close); }
  if(closeBody) { closeBody.addEventListener('click', close); }
  if(closeHeader) { closeHeader.addEventListener('click', close); }

  // if (blue.prop.media.md.matches) {
  //  if (!storage && bodyClass) {
  //    window.sessionStorage.setItem('signIn', 'true');
  //    setTimeout(() => {
  //      init();
  //    }, 250)
  //  }
  // }
  // blue.prop.media.md.addListener((e) => {
  //  if (blue.prop.media.md.matches) {
  //    if (!storage) {
  //      window.sessionStorage.setItem('signIn', 'true')
  //      setTimeout(() => {
  //        init();
  //      }, 250)
  //    }
  //  }
  // });
});

const readMeassagesKey = 'readMessages';
let readMessages = window.sessionStorage.getItem(readMeassagesKey);
if (!readMessages) {
  readMessages = [];
  window.sessionStorage.setItem(readMeassagesKey, readMessages);
} else {
  readMessages = readMessages.split(',');
}
//toggle messages
blue.ready('headerMessages', '.header-utilMessagesTrigger', trigger => {
  const messagesMenu = document.querySelector('.header-utilMessagesMenu');

  if (readMessages.length > 0) {
    readMessages.forEach(function (id) {
      let query = '[data-id="' + id + '"]';
      let message = document.querySelector(query);
      message.classList.remove('header-utilMessagesItem--new');
      message.classList.add('header-utilMessagesItem--read');
      message.classList.add('header-utilMessagesItem');
    });
  }

  updateCount();
  const newMessages = document.querySelectorAll(
    '.header-utilMessagesItem--new'
  );
  newMessages.forEach(function (message, index) {
    message.addEventListener('click', e => {
      markAsRead(e.currentTarget);
    });
  });

  trigger.addEventListener('click', e => {
    e.preventDefault();

    trigger.classList.toggle('is-active');
    messagesMenu.classList.toggle('is-active');
  });

  document.body.addEventListener('click', e => {
    if (
      trigger.matches('.is-active') &&
      !e.target.closest('.header-utilMessages')
    ) {
      trigger.classList.remove('is-active');
      messagesMenu.classList.remove('is-active');
    }
  });
});

function updateCount() {
  const newMessages = document.querySelectorAll(
    '.header-utilMessagesItem--new'
  );
  if (newMessages.length === 0) {
    markAllRead();
  } else {
    const messageCount = document.querySelector('.header-utilMessagesCount');
    if (messageCount) {
      messageCount.textContent = newMessages.length;
    }
  }
}

function markAsRead(message) {
  if (message) {
    if (!readMessages.includes(message.getAttribute('data-id')))
      readMessages.push(message.getAttribute('data-id'));

    window.sessionStorage.setItem(readMeassagesKey, readMessages);
    message.classList.remove('header-utilMessagesItem--new');
    message.classList.add('header-utilMessagesItem--read');
    message.classList.add('header-utilMessagesItem');

    updateCount();
  }
}

function markAllRead() {
  const messagesWrapper = document.querySelector('.header-utilMessages');
  if (messagesWrapper) {
    messagesWrapper.classList.add('all-read');
  }

  const messages = document.querySelectorAll('.header-utilMessagesItem');

  if (messages) {
    messages.forEach(function (message) {
      if (!readMessages.includes(message.getAttribute('data-id'))) {
        readMessages.push(message.getAttribute('data-id'));
      }

      message.classList.remove('header-utilMessagesItem--new');
      message.classList.add('header-utilMessagesItem--read');
      message.classList.add('header-utilMessagesItem');
    });

    window.sessionStorage.setItem(readMeassagesKey, readMessages);
  }
}

//mark all as read
blue.ready('headerMessagesAllRead', '.header-utilMessagesAllRead', trigger => {
  trigger.addEventListener('click', e => {
    e.preventDefault();
    markAllRead();
  });
});

//toggle nav desktop
blue.ready(
  'toggleNav_desktop',
  '.header-navMenu > .header-navItem--children',
  item => {
    const links = [...item.querySelectorAll(':scope > .header-navHeading')];
    let sibs = [
      ...item
        .closest('.header-navMenu')
        .querySelectorAll(':scope > .header-navItem'),
    ];

    sibs = sibs.filter(sib => sib != item);

    for (let link of links) {
      link.addEventListener('click', e => {
        if (blue.prop.media.default.matches) {
          e.preventDefault();
          sibs.forEach(itm => itm.classList.remove('is-active'));
          item.classList.toggle('is-active');
        }
      });
    }

    blue.prop.media.default.addListener(e => {
      if (!e.matches) {
        item.classList.remove('is-active');
      }
    });
  }
);

//toggle nav mobile
blue.ready(
  'toggleNav',
  '.header:not(.header--stripped):not(.header--landing)',
  header => {
    const trigger = header.querySelector('.header-navTrigger'); //mobile trigger
    const utilNav = header.querySelector('.header-utilNav'); //outer nav container
    const nav = header.querySelector('.header-nav'); //outer nav container
    const inner = nav.querySelector('.header-navInner'); //inner nav container
    const parents = [...inner.querySelectorAll('.header-navItem--children')]; //menu items with children
    const backs = [...inner.querySelectorAll('.header-navItem--back')]; //back buttons (inside parents)
    const level = {
      depth: 0,
      get current() {
        return this.depth * -100;
      },
      set change(x) {
        if (x == 0) {
          this.depth = 0;
        } else {
          this.depth = this.depth + x;
        }
      },
    };
    let subs; // container for sub menu ul's

    // function to open/reset the menu of click of trigger
    const toggle = () => {
      if (!blue.prop.media.default.matches) {
        if (trigger.classList.contains('is-active')) {
          reset();
        } else {
          trigger.classList.add('is-active');
          nav.classList.add('is-active');
          blue.meth.bodyLock.lock(nav);
        }
      }
    };

    //function to descend into menu (click on an item with children)
    const descend = parent => {
      if (!blue.prop.media.default.matches) {
        level.change = 1;
        inner.style.transform = `translateX(${level.current}%)`;
        parent.classList.add('is-sub-active');
      }
    };

    //function to ascend in menu (click on a back button)
    const ascend = parent => {
      if (!blue.prop.media.default.matches) {
        level.change = -1;
        inner.style.transform = `translateX(${level.current}%)`;
        parent.classList.remove('is-sub-active');
      }
    };

    //reset all menu classes, styles, and variables to default state;
    const reset = e => {
      subs = [...header.querySelectorAll('.is-sub-active')];
      trigger.classList.remove('is-active');
      inner.style.transform = '';
      level.change = 0;
      subs.forEach(sub => sub.classList.remove('is-sub-active'));

      // close nav
      if (nav) {
        if (
          !e ||
          (e.target.closest('.header-nav') == null &&
            e.target.closest('.header-navTrigger') == null)
        ) {
          nav.classList.remove('is-active');
          [...nav.querySelectorAll('.is-active')].forEach(item =>
            item.classList.remove('is-active')
          );
          blue.meth.bodyLock.unlock(nav);
        }
      }

      // close utility nav
      if (utilNav) {
        if (!e || e.target.closest('.header-utilNav') == null) {
          [...utilNav.querySelectorAll('.is-active')].forEach(item =>
            item.classList.remove('is-active')
          );
        }
      }
    };

    // document click handler, if user touches/clicks outside of menu space then close menu
    const offclick = e => {
      if (
        e.target.closest('.header-nav') == null &&
        e.target.closest('.header-navTrigger') == null
      ) {
        reset();
      }
    };

    //add descend click event to parents
    for (let parent of parents) {
      let trigger = parent.querySelector('.header-navIcon');
      trigger.addEventListener('click', e => {
        if (!blue.prop.media.default.matches) {
          // if (e.target.parentElement == parent) {
            e.preventDefault();
            e.stopPropagation();
            descend(parent);
          // }
        }
      });
    }

    //add ascend click event to back buttons
    for (let back of backs) {
      back.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();
        if (!blue.prop.media.default.matches) {
          const parent = back.closest('.header-navItem--children');
          ascend(parent);
        }
      });
    }

    // add toggle click event to trigger
    trigger.addEventListener('click', e => {
      if (!blue.prop.media.default.matches) {
        e.preventDefault();
        toggle();
      }
    });

    //reset menu when we hit the desktop size
    blue.prop.media.default.addListener(e => {
      if (e.matches) {
        reset();
      }
    });

    //reset menu when we click on outside of the menu
    ['click', 'touchstart'].forEach(function (e) {
      document.addEventListener(e, offclick);
    });
  }
);

//toggle utility nav
blue.ready(
  'toggleUtilityNav',
  '.header-utilNavMenu > .header-utilNavItem',
  item => {
    const subNav = item.querySelector('.header-utilNavSub');

    if (subNav) {
      item.classList.add('has-children');
      const links = [...item.querySelectorAll(':scope > .header-utilNavLink')];
      let sibs = [
        ...item
          .closest('.header-utilNavMenu')
          .querySelectorAll(':scope > .header-utilNavItem'),
      ];

      sibs = sibs.filter(sib => sib != item);

      for (let link of links) {
        link.addEventListener('click', e => {
          e.preventDefault();
          sibs.forEach(itm => itm.classList.remove('is-util-active'));
          item.classList.toggle('is-util-active');
        });
      }

      blue.prop.media.default.addListener(e => {
        item.classList.remove('is-util-active');
      });

      // document click handler, if user touches/clicks outside of menu space then close menu
      const offclick = e => {
        if (e.target.closest('.header-utilNavMenu') == null) {
          item.classList.remove('is-util-active');
          sibs.forEach(sibs => sibs.classList.remove('is-util-active'));
        }
      };

      //reset menu when we click on outside of the menu
      ['click', 'touchstart'].forEach(function (e) {
        document.addEventListener(e, offclick);
      });
    }
  }
);

blue.ready('search', '.header-search', search => {
  const trigger = search.querySelector('.header-searchTrigger');
  const bar = search.querySelector('.header-searchBar');
  const input = search.querySelector('.header-searchInput');
  const button = search.querySelector('.header-searchIcon');

  const toggle = e => {
    if (e.type == 'click' || e.code == 'Escape') {
      let initHeight = bar.offsetHeight;
      let finalHeight;

      search.classList.toggle('is-active');
      finalHeight = bar.offsetHeight;

      bar.animate(
        [
          {
            height: `${initHeight}px`,
          },
          {
            height: `${finalHeight}px`,
          },
        ],
        {
          duration: 250,
          easing: 'ease',
        }
      );

      input.value = '';
      if (search.classList.contains('is-active')) {
        input.focus();
      }
    }
  };

  const doSearch = e => {
    if (e.type == 'click' || e.code == 'Enter') {
      e.preventDefault();
      if (input.value.trim().length) {
        window.location.href = `${input.getAttribute(
          'data-search'
        )}?searchtext=${input.value}`;
      }
    }
  };

  trigger.addEventListener('click', toggle);
  input.addEventListener('keyup', toggle);
  input.addEventListener('keyup', doSearch);
  button.addEventListener('click', doSearch);
});

blue.ready(
  'submitLogin',
  '.header:not(.header--stripped):not(.header--landing)',
  header => {
    const inputs = [...header.querySelectorAll('.header-utilAccountInput')];
    const submit = header.querySelector('.header-utilAccountBtn--signIn');
    const url = 'https://online.uhcu.org/UHCUOnline_41/uux.aspx';
    let params = {};

    const valid = () => {
      let valid = true;
      inputs.forEach(input => {
        if (input.value) {
          input.classList.remove('is-error');
          if (input.getAttribute('type') == 'password') {
            params.password = input.value;
          } else {
            params.user_id = input.value;
          }
        } else {
          input.classList.add('is-error');
          valid = false;
        }
      });

      return valid;
    };

    const login = e => {
      e.preventDefault();
      if (valid()) {
        let form = document.createElement('FORM');
        form.setAttribute('method', 'post');
        form.setAttribute('action', url);

        Object.keys(params).forEach(key => {
          let field = document.createElement('INPUT');
          field.setAttribute('type', 'hidden');
          field.setAttribute('name', key);
          field.setAttribute('value', params[key]);
          form.appendChild(field);
        });
        document.body.appendChild(form);
        form.submit();
      }
    };

    if (submit) {
      submit.addEventListener('click', login);
    }
    inputs.forEach(input =>
      blue.meth.addEvents(input, 'enter.stop.prevent', login)
    );
  }
);

blue.ready(
  'forgotPassword',
  '.header:not(.header--stripped):not(.header--landing)',
  header => {
    const inputs = [...header.querySelectorAll('.header-utilAccountInput')];
    const submit = header.querySelector('.header-utilAccountLink--forgot');
    const url = 'https://online.uhcu.org/UHCUOnline_41/uux.aspx';
    let params = {};

    const valid = () => {
      let valid = true;
      inputs.forEach(input => {
        if (input.getAttribute('type') != 'password') {
          if (input.value) {
            input.classList.remove('is-error');
            params.user_id = input.value;
            params.forgot_password = true;
          } else {
            input.classList.add('is-error');
            valid = false;
          }
        }
      });
      return valid;
    };

    const login = e => {
      e.preventDefault();
      if (valid()) {
        let form = document.createElement('FORM');
        form.setAttribute('method', 'post');
        form.setAttribute('action', url);

        Object.keys(params).forEach(key => {
          let field = document.createElement('INPUT');
          field.setAttribute('type', 'hidden');
          field.setAttribute('name', key);
          field.setAttribute('value', params[key]);
          form.appendChild(field);
        });
        document.body.appendChild(form);
        form.submit();
      }
    };

    if (submit) {
      submit.addEventListener('click', login);
    }
  }
);

//retach util
// blue.ready('retach_header', '.header-utilNav', util => {
//   blue.plug.retach(util, {
//     destination: '.header-navInner',
//     mediaQuery: 990,
//   });
// });

blue.ready('headerLanding', '.header--landing', header => {
  const trigger = header.querySelector('.header-navTrigger'); //mobile trigger
  const nav = header.querySelector('.header-nav'); //outer nav container

  // function to open/reset the menu of click of trigger
  const toggle = () => {
    if (!blue.prop.media.default.matches) {
      if (trigger.classList.contains('is-active')) {
        reset();
      } else {
        trigger.classList.add('is-active');
        nav.classList.add('is-active');
        blue.meth.bodyLock.lock(nav);
      }
    }
  };

  //reset all menu classes, styles, and variables to default state;
  const reset = () => {
    trigger.classList.remove('is-active');
    nav.classList.remove('is-active');
    [...nav.querySelectorAll('.is-active')].forEach(item =>
      item.classList.remove('is-active')
    );
    blue.meth.bodyLock.unlock(nav);
  };

  // add toggle click event to trigger
  trigger.addEventListener('click', e => {
    if (!blue.prop.media.default.matches) {
      e.preventDefault();
      toggle();
    }
  });

  //reset menu when we hit the desktop size
  blue.prop.media.default.addListener(e => {
    if (e.matches) {
      reset();
    }
  });

  //reset menu when we click on outside of the menu
  document.addEventListener('click', function (e) {
    if (
      e.target.closest('.header-nav') == null &&
      e.target.closest('.header-navTrigger') == null
    ) {
      reset();
    }
  });

  document.addEventListener('touchstart', function (e) {
    if (
      e.target.closest('.header-nav') == null &&
      e.target.closest('.header-navTrigger') == null
    ) {
      reset();
    }
  });
});
